import { useTranslation } from '@common/utils';
import { useSettings } from '@common/hooks';

import defaultUniversities from '../../../Coliving/universities.json';
import defaultFaculties from '../../../Coliving/faculties.json';
import countries from '../../../Coliving/countries.json';

const defaultSourceOfDiscoveryOptions = [
	{ value: 'googleSearch', label: 'Google search' },
	{ value: 'socialMedia', label: 'Social media' },
	{ value: 'onlineAdvertisement', label: 'Online advertisement' },
	{ value: 'emailCampaign', label: 'Email campaign' },
	{ value: 'friendOrFamilyMember', label: 'Referral from a Friend or Family Member' },
	{ value: 'other', label: 'Other' },
];

function options() {
	const tr = useTranslation();

	const { universities, faculties, sourceOfDiscoveryOptions } = useSettings();

	return {
		'typeOfStudent': [
			{ value: 'exchangeFiveMonths', label: tr('Exchange (Erasmus 5 months)') },
			{ value: 'exchangeTenMonths', label: tr('Exchange (Erasmus 10 months)') },
			{ value: 'fullTime', label: tr('Full-time') },
		],
		'gender': [
			{ value: 'male', label: tr('Male') },
			{ value: 'female', label: tr('Female') },
			{ value: 'other', label: tr('Other') },
		],
		'stayPurpose': [
			{ value: 'study', label: tr('Study') },
			{ value: 'work', label: tr('Work') },
			{ value: 'leisure', label: tr('Leisure') },
		],
		'studyYear': [
			{ value: 1, label: '1' },
			{ value: 2, label: '2' },
			{ value: 3, label: '3' },
			{ value: 4, label: '4' },
			{ value: 5, label: '5' },
			{ value: 6, label: '6' },
		],
		'universityName': universities.length > 0 ? universities : defaultUniversities,
		'faculty': faculties.length > 0 ? faculties : defaultFaculties,
		'country': countries,
		'sourceOfDiscovery': sourceOfDiscoveryOptions.length > 0 ? sourceOfDiscoveryOptions : defaultSourceOfDiscoveryOptions,
	};
}

export default options;
